exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "img.game-image {\r\n    width: 100%;\r\n    height: 170px;\r\n}\r\n.gallery__name{\r\n    font-size: 12px !important;\r\n}\r\n.gallery__item-inner.card{\r\n    max-width: 275px;\r\n    margin-left: auto;\r\n    margin-right: auto;\r\n}\r\n@media screen and (max-width: 450px){\r\n    .group-game-item-container{\r\n        width: 100%;\r\n    }\r\n\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Users/IsaGul/Desktop/beyn-projects/commercial-front-end/src/app/shared/components/group-game-item/group-game-item.component.css
// module id = ../../../../../src/app/shared/components/group-game-item/group-game-item.component.css
// module chunks = main